import { render, staticRenderFns } from "./worldCupWinner.vue?vue&type=template&id=707f451c"
import script from "./worldCupWinner.vue?vue&type=script&lang=js"
export * from "./worldCupWinner.vue?vue&type=script&lang=js"
import style0 from "./worldCupWinner.vue?vue&type=style&index=0&id=707f451c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports